module.exports = __webpack_public_path__ + "static/media/icon-download-google.8ec97ffa.png";